import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, CircularProgress, Button, Box } from '@mui/material';
import { api } from '../services/api';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await api.verifyEmail(token);
        setStatus('success');
      } catch (error) {
        setStatus('error');
      }
    };

    verifyEmail();
  }, [token]);

  const renderContent = () => {
    switch (status) {
      case 'verifying':
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>Verificando tu correo electrónico...</Typography>
          </Box>
        );
      
      case 'success':
        return (
          <>
            <Typography variant="h5" gutterBottom>
              ¡Email verificado exitosamente!
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              Tu cuenta ha sido verificada. Ya puedes comenzar a usar la plataforma.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/login')}
              sx={{ mt: 3 }}
            >
              Ir al inicio de sesión
            </Button>
          </>
        );
      
      case 'error':
        return (
          <>
            <Typography variant="h5" color="error" gutterBottom>
              Error de verificación
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              El enlace de verificación es inválido o ha expirado.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/login')}
              sx={{ mt: 3 }}
            >
              Volver al inicio de sesión
            </Button>
          </>
        );
    }
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {renderContent()}
      </Paper>
    </Container>
  );
};

export default VerifyEmail; 